import React from 'react';

type CountUnits = [one: string, few: string, many: string];

export const PLAYER_UNITS: CountUnits = ['zawodnik', 'zawodników', 'zawodników'];
export const PAIR_UNITS: CountUnits = ['para', 'pary', 'par'];
export const MATCH_UNITS: CountUnits = ['mecz', 'mecze', 'meczów'];

export function countLabel(count: number, [one, few, many]: CountUnits): string {
  if (count === 1) {
    return `1 ${one}`;
  }

  const lastDigit = count % 10;
  const lastTwo = count % 100;
  const isFew = lastDigit >= 2 && lastDigit <= 4 && (lastTwo < 12 || lastTwo > 14);

  return `${count} ${isFew ? few : many}`;
}

interface Props {
  title: string;
  count: string;
  children: React.ReactNode;
}

export function ScoringSectionLine({ title, count, children }: Props): JSX.Element {
  return (
    <div className="scoring-group__line">
      <h3 className="scoring-group__subtitle">{title}</h3>
      <span className="scoring-group__aside">
        <span className="scoring-group__count">{count}</span>
        {children}
      </span>
    </div>
  );
}

export default ScoringSectionLine;
